import { Column, Row } from 'app/design/primitives/box';
import { Switch } from 'app/design/primitives/switch';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import type { NotificationToggle } from './notification-toggle.types';

const theme = createDSTheme();

export const ToggleRows = ({ toggles }: { toggles: NotificationToggle[] }) => (
  <Column gap="spacing.general.x4">
    {toggles.map(({ label, value, onValueChange }) => (
      <Row
        alignItems="center"
        key={label}
        style={{
          paddingHorizontal: theme.spacing['spacing.general.x4'],
          paddingVertical: theme.spacing['spacing.general.x2'],
          backgroundColor: theme.colors['surface.tertiary-neutral'],
          borderRadius: theme.borderRadii['radius.sm'],
        }}
      >
        <Text flex={1} fontWeight="700" variant="bodyBase">
          {label}
        </Text>
        <Switch onValueChange={onValueChange} value={value} />
      </Row>
    ))}
  </Column>
);
